
import React, { Component } from 'react';

/**
 * CustomTabs — drop-in replacement for @atlaskit/tabs used in DialogWithTabs.
 * All styling via CSS classes in _custom_dialog.scss — no inline styles.
 *
 * Atlaskit Tabs API used in this codebase:
 *   <Tabs
 *       onSelect={this._onTabSelected}
 *       selected={this.state.selectedTab}
 *       tabs={[ { label: string, content: ReactNode }, ... ]} />
 *
 * Where onSelect(tab, tabIndex) is called when a tab is clicked.
 */
class CustomTabs extends Component {

    /**
     * Initializes a new CustomTabs instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._onTabClick = this._onTabClick.bind(this);
    }

    /**
     * Handles tab click events.
     *
     * @param {Object} tab - The clicked tab object.
     * @param {number} index - The index of the clicked tab.
     * @returns {void}
     */
    _onTabClick(tab, index) {
        const { onSelect } = this.props;

        onSelect && onSelect(tab, index);
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { tabs = [], selected = 0 } = this.props;

        if (!tabs.length) {
            return null;
        }

        const selectedTab = tabs[selected];

        return (
            <div className = 'custom-tabs'>
                {/* Tab bar */}
                <div
                    className = 'custom-tabs__bar'
                    role = 'tablist'>
                    {tabs.map((tab, idx) => {
                        const isSelected = idx === selected;

                        return (
                            <button
                                aria-selected = { isSelected }
                                className = { `custom-tabs__btn${isSelected ? ' custom-tabs__btn--selected' : ''}` }
                                key = { tab.label || idx }
                                onClick = { () => this._onTabClick(tab, idx) }
                                role = 'tab'
                                type = 'button'>
                                {tab.label}
                            </button>
                        );
                    })}
                </div>

                {/* Active tab content */}
                <div
                    aria-live = 'polite'
                    className = 'custom-tabs__content'
                    role = 'tabpanel'>
                    {selectedTab && selectedTab.content}
                </div>
            </div>
        );
    }
}

export default CustomTabs;
